export default __webpack_public_path__ + "4afa347573c6908f5de94e196dae4433.svg";